import type { ImageLoaderProps } from 'next/image';

const normalizeSrc = (src: string) => {
  return src.startsWith('/') ? src.slice(1) : src;
};

export default function cloudflareLoader({ src, width, quality }: ImageLoaderProps) {
  const params = [`width=${width}`];
  if (quality) {
    params.push(`quality=${quality}`);
  }

  // In development, return the original URL with query params
  if (process.env.NODE_ENV === 'development') {
    return `${src}?${params.join('&')}`;
  }

  // In production, use Cloudflare's image transformation
  return `https://sizzle.nz/cdn-cgi/image/${params.join(',')}/${normalizeSrc(src)}`;
}
